<template>
    <div class="middlebg">
        <img :src="imgurl" alt="" onclick="return false;" >
    </div>
</template>

<script>
    export default {
        name:'pcmiddlebg',
        props: ['imgurl']
    }
</script>

<style  scoped>
    @media screen and (min-width: 768px){
        .middlebg {
            position: relative;
            width: 55%;
            height:53%;
            margin:100px auto 0 auto;
        }
        .middlebg img{
            width:100%;
            height:auto;
        }
    }
</style>